<span *ngIf="dateRange.option != 'Custom'">
  {{ dateRange.option | spaceCapCase }}
</span>
<span *ngIf="dateRange.option == 'Custom'">
  {{ dateRange.since?.format('YYYY-MM-DD') }}
  -
  {{ dateRange.until?.format('YYYY-MM-DD') }}
</span>
